<template>
  <form ref="form">
      <slot></slot>
  </form>
</template>
<script>
export default {
  name:'Form'
}
</script>





// WEBPACK FOOTER //
// Form.vue?214e4208